import { computed } from "vue";
export const bankTransactionsEnabled = computed(() => {
    return window.marque.ui.features.bank_transactions === true;
});
export const bankTransactionsEnabledGetter = () => {
    return bankTransactionsEnabled.value;
};
export const autoEntryEnabled = computed(() => {
    return window.marque.ui.authorisations['ai.auto_entry'];
});
export const autoEntryEnabledGetter = () => {
    return autoEntryEnabled.value;
};
export const assistantEnabled = computed(() => {
    return window.marque.ui.authorisations['ai.assistant'];
});
export const assistantEnabledGetter = () => {
    return assistantEnabled.value;
};
